<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
            )
                div
                    el-button(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaHa') }}:
                |
                | {{ formatNumber(restricao?.areaTotalFeatureHa || restricao?.area) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.percentualDeSobreposicao') }}:
                |
                | {{ formatNumberPercent(restricao.percentualSobreposicaoGeometria) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.codigo') }}:
                |
                | {{ restricao.codigo || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataCriacao') }}:
                |
                | {{ restricao.data_criac || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.codigoProcesso') }}:
                |
                | {{ restricao.codigo_pro || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.codigoInfracao') }}:
                |
                | {{ restricao.codigo_inf || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.municipio') }}:
                |
                | {{ restricao.municipio || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.infracao') }}:
                |
                | {{ restricao.infracao || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.categoria') }}:
                |
                | {{ restricao.categoria || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nivelAlerta') }}:
                | {{ restricao.nivelAlerta }}
                i.m-2.el-icon-remove-outline.custon-icon-el(
                    v-if='restricao.status && restricao.status === "ERROR"'
                )
                i.m-2.flow.flow-verified.verde.mr8.custon-icon(
                    v-else-if='restricao.nivelAlerta && restricao.nivelAlerta === "BAIXO"'
                )
                i.m-2.flow.flow-warning-sign.amarelo.mr8.custon-icon(
                    v-else-if='restricao.nivelAlerta && restricao.nivelAlerta === "MEDIO"'
                )
                i.m-2.flow.flow-warning-sign.vermelho.mr8.custon-icon(
                    v-else='(restricao.nivelAlerta && restricao.nivelAlerta === "ALTO") || !restricao.nivelAlerta'
                )
</template>

<script>
import formatters from '@/utils/formatters';
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
export default {
    name: 'area-embargada-goias',
    emits: ['highlightGeometry'],
    components: {
        Criticidade
    },
    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes
            );
        },
        dataFormatada(data) {
            if (data && data.length > 0) {
                let ano = data.substring(0, 4);
                let mes = data.substring(5, 7);
                let dia = data.substring(8, 10);

                return dia + '/' + mes + '/' + ano;
            } else {
                return '-';
            }
        },
        formatNumber(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2);
        },

        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        }
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>
